import { KVKKMenuItems } from 'lib/staticPageMenuItems';
import { MenuWrapper } from 'components/account/AccountMenu';
import { StaticMenuItems } from 'components/contracts';
import { PageMenuContainer } from 'components/styles/StaticPagesStyles';

const KVKKMenu = () => (
    <PageMenuContainer>
        <MenuWrapper alignItems="start" type="kvkk">
            {KVKKMenuItems.map((KVKKMenuItems) => (
                <StaticMenuItems
                    key={KVKKMenuItems.slug}
                    slug={KVKKMenuItems.slug}
                    name={KVKKMenuItems.name}
                    fontSize="10px"
                />
            ))}
        </MenuWrapper>
    </PageMenuContainer>
);

export default KVKKMenu;
